import { css, cva, cx } from "@styled-system/css";
import { token } from "@styled-system/tokens";

export const spinner = cva({
  base: {
    borderWidth: "3px",
    borderColor: "primary",
    borderStyle: "solid",
    borderRadius: "100%",
    animation: "spin",
    borderBottomColor: "transparent",
    borderLeftColor: "transparent",
    animationDuration: "500ms"
  }
});

export default function Spinner({ size = "32", className }: { size?: Theme.Sizes; className?: string } = {}) {
  return (
    <div
      className={cx(
        css({
          width: "var(--spinner-size)",
          height: "var(--spinner-size)"
        }),
        spinner(),
        className
      )}
      style={
        {
          "--spinner-size": token(`sizes.${size}` as `sizes.${Theme.Sizes}`)
        } as React.CSSProperties
      }
    />
  );
}
